import * as React from "react";

function SvgRetweet(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 15"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M6 11.25V5h2.4L4.2 0 0 5h2.4v7.5A2.45 2.45 0 004.8 15h11.38L13 11.25zm5-7.5L7.82 0H19.2a2.46 2.46 0 012.4 2.5V10H24l-4.2 5-4.2-5H18V3.75z" />
    </svg>
  );
}

const MemoSvgRetweet = React.memo(SvgRetweet);
export default MemoSvgRetweet;
